import React from 'react';
import { NavLink } from 'react-router-dom';
import Style from './style';

function Navigation({ children }) {

    function deleteDefaultCoachProgram() {
        localStorage.removeItem('defaultCoachProgram')
        localStorage.removeItem('directRequestData')

    }

    return (
        <Style>
            {children}
            <footer id="navigation" className="bg-white mx-auto">
                <div className="d-flex flex-row justify-content-around align-items-center text-center mx-auto">
                    <NavLink className="navbar col-2 home" activeClassName="homeActive" to="/home">
                        <p>خانه</p>
                    </NavLink>
                    <NavLink
                        className="navbar col-2 plans"
                        activeClassName="plansActive"
                        onClick={deleteDefaultCoachProgram}
                        to="/plans"
                    >
                        <p>برنامه‌ها</p>
                    </NavLink>
                    <NavLink
                        className="listItemIcons col-4 message mx-1"
                        activeClassName="messageActive"
                        to="/direct"
                    ></NavLink>
                    <NavLink
                        className="navbar col-2 financial"
                        activeClassName="financialActive"
                        to="/financial"
                    >
                        <p>مالی</p>
                    </NavLink>
                    <NavLink className="navbar col-2 more" activeClassName="moreActive" to="/more">
                        <p>بیشتر</p>
                    </NavLink>
                </div>
            </footer>
        </Style>
    );
}

export default Navigation;
